<template>
  <q-tr :props="data">
    <q-td
        key="id"
        :props="data"
        class="text-subtitle1"
        auto-width
    >
      <strong>{{ data.row.id }}</strong>
    </q-td>

    <q-td
        key="state"
        :props="data"
        auto-width
    >
      <super-dropdown :model="schema"/>
    </q-td>

    <q-td
        v-if="hasAccount"
        key="account"
        :props="data"
        auto-width
    >
      <div v-if="data.row._embedded.account">
        {{ `${data.row._embedded.account.name} (${data.row._embedded.account.id})` }}
      </div>
    </q-td>

    <q-td
        v-if="hasPayer"
        key="payer"
        :props="data"
        auto-width
    >
      <div v-if="data.row._embedded.payer">
        {{ `${data.row._embedded.payer.name} (${data.row._embedded.payer.id})` }}
      </div>
    </q-td>

    <q-td
        v-if="hasPayee"
        key="payee"
        :props="data"
        auto-width
    >
      <div v-if="data.row._embedded.payee">
        {{ `${data.row._embedded.payee.name} (${data.row._embedded.payee.id})` }}
      </div>
    </q-td>

    <q-td
        key="created"
        :props="data"
        auto-width
    >
      {{ $moment(data.row.created.date).format(appOptions.formats.date) }}
    </q-td>

    <q-td
        key="value"
        :props="data"
        auto-width
    >
      {{ data.row.value }}
    </q-td>

    <q-td
        key="history"
        :props="data"
        auto-width
    >
      <q-btn
          color="dark"
          icon="history"
          size="sm"
          round
          @click="openHistory"
      />
    </q-td>

    <q-td
        key="documents"
        :props="data"
        auto-width
    >

      <q-btn-dropdown
          v-if="data.row && data.row.eav && data.row.eav['accounts-auto-generated'] && data.row.eav['accounts-report']"
          :class="'full-width q-mt-md'"
          size="sm"
          color="light-blue-9"
          class="q-ml-sm"
          no-caps
          @click="onRequest"
      >
        <q-list>
          <q-item
              v-for="option in reports"
              :key="option.id"
              clickable
              v-close-popup
              @click="handleClick(option)"
          >
            <q-item-section>
              <q-item-label>
                {{ option.name }}
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>

      <action-lazy-dropdown v-else :option="options"/>
    </q-td>

    <q-td
        key="payee"
        :props="data"
        auto-width
    >
      <q-btn
          icon="person_pin_circle"
          size="lg"
          flat
          round
          dense
          @click="handlePaymentActive"
      />
      <!--        :disable="data.row.state === 'paid' || data.row.state === 'deleted'"-->
    </q-td>

    <q-td
        key="payment"
        :props="data"
        auto-width
    >
      <div v-if="data.row && data.row.eav && data.row.eav['integrations-accounts-invoice-pay-link']">
        <q-btn
            icon="payments"
            size="lg"
            flat
            round
            dense
            color="positive"
            @click="handlePayment"
        />
      </div>
      <div v-else>
        {{ '--' }}
      </div>

    </q-td>

    <q-dialog v-model="historyModal">
      <q-card style="min-width: 65vw;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">
            {{ $t('History') }}
          </div>

          <q-space/>

          <q-btn
              v-close-popup
              icon="close"
              flat
              round
              dense
          />
        </q-card-section>

        <q-card-section>
          <history
              :id="data.row.id"
              :entity="entityClass"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-tr>
  <legal-entities-modal ref="legalEntitiesModal" @submit="handleSubmit"/>
</template>

<script>
// Vuex
import { mapGetters, mapMutations } from 'vuex'

// Components
import ActionLazyDropdown from '../action-header/ActionLazyDropdown.vue'
import History from '../history/history.vue'
import SuperDropdown from '../super-dropdown/SuperDropdown.vue'
import LegalEntitiesModal from '../../components/modals/LegalEntitiesModal.vue'

export default {
  name: 'InvoiceRow',
  emits: ['submit'],
  components: {
    LegalEntitiesModal,
    SuperDropdown,
    History,
    ActionLazyDropdown
  },
  props: {
    hasAccount: {
      type: Boolean,
      default () {
        return false
      }
    },
    hasPayee: {
      type: Boolean,
      default () {
        return false
      }
    },
    hasPayer: {
      type: Boolean,
      default () {
        return false
      }
    },
    data: {
      type: Object,
      required: true,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      entityClass: 'Orderadmin\\Accounts\\Entity\\Invoice',
      historyModal: false,
      reports: [],
      stateColors: {
        pending: 'info',
        conditionally_paid: 'yellow',
        confirmed: 'green',
        paid: 'success',
        voided: 'gray',
        failed: 'danger',
        deleted: 'danger'
      },
      statesList: [
        {
          buttons: [
            { id: 'pending', title: 'Pending', transitions: ['confirmed', 'paid', 'voided', 'failed'], color: 'info' },
            { id: 'conditionally_paid', title: 'Conditionally paid', transitions: [], color: 'yellow' },
            { id: 'confirmed', title: 'Confirmed', transitions: ['paid'], color: 'green' },
            { id: 'paid', title: 'Paid', transitions: [], color: 'success' },
            { id: 'voided', title: 'Voided', transitions: [], color: 'gray' },
            { id: 'failed', title: 'Failed', transitions: ['confirmed', 'paid', 'voided'], color: 'danger' },
            { id: 'deleted', title: 'Deleted', transitions: [], color: 'danger' }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'appOptions',
      'isSupervisior',
      'isAdministrator'
    ]),
    options () {
      return {
        color: 'light-blue-9',
        options: [],
        noOptions: this.$t('No option for download'),
        onScroll: (search, page) => {
          const query = {
            search,
            page,
            filter: [
              { type: 'eq', field: 'state', value: 'active' },
              { type: 'eq', field: 'entityClass', value: this.entityClass }
            ]
          }

          return this.$service.documentTemplate.getAll(query)
        },
        onClick: (item) => {
          return this.$service.invoice.getTemplate(this.data.row.id, item.id)
              .then(data => {
                this.$service.printer.print(data, undefined, true)
                this.stopLoading()
              })
              .catch(error => {
                this.stopLoading()
                this.addErrorNotification(error)
              })
        }
      }
    },
    states () {
      if (!this.isSupervisior && !this.isAdministrator && this.data.row.state === 'pending') {
        const filteredStatesList = Object.values(this.statesList[0].buttons).filter((state) => {
          const id = state.id // Assuming 'id' is a property of each state object
          return id === 'pending' || id === 'confirmed' || id === 'voided'
        })

        return [
          {
            buttons: filteredStatesList
          }
        ]
      }

      return this.statesList
    },
    isStatusesDisabled () {
      if (this.isSupervisior || this.isAdministrator || this.data.row.state === 'pending') {
        return false
      }

      return true
    },
    schema () {
      const value = this.states[0].buttons.find(({ id }) => id === this.data.row.state) || {
        id: 'pending',
        title: 'Pending',
        color: 'info'
      }

      const option = {
        id: 'statuses',
        type: 'super-dropdown',
        variant: 'link',
        color: value.color || 'default',
        disabledLabels: true,
        disabled: this.isStatusesDisabled,
        editableFields: false,
        onClick: (state) => {
          this.$service.invoice.save({ state }, this.data.row.id)
              .then(item => {
                this.$emit('submit', item)

                if (state === 'deleted') {
                  this.removeInvoice(item)
                } else {
                  this.upsertInvoice(item)
                }
              })
        },
        value,
        options: this.states
      }

      return option
    }
  },
  methods: {
    ...mapMutations([
      'upsertInvoice',
      'removeInvoice',
      'stopLoading',
      'addErrorNotification'
    ]),
    handlePayment () {
      window.open(this.data.row.eav['integrations-accounts-invoice-pay-link'], '_blank')
    },
    handlePaymentActive () {

      this.$refs.legalEntitiesModal.open(this.data.row)
    },
    openHistory () {
      this.historyModal = true
    },
    handleSubmit (item) {
      this.$emit('submit', item)
    },
    handleClick (report) {
      window.open(report.file, '_blank')
    },
    onRequest () {
      const query = {
        filter: [
          { type: 'eq', field: 'id', value: this.data.row.eav['accounts-report'] }
        ]
      }

      this.$service.report.getAll(query)
          .then(e => {
            const result = []

            e?.items.forEach(item => {
              const documents = item.data?.documents

              if (documents) {
                result.push(...Object.values(documents))
              }
            })

            this.reports = result
            return result
          })
    }
  }
}
</script>
